exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-detail-form-center .form-row[data-v-1be0512c]{width:calc(100% - 60px)}.modal-detail-form-center .form-row .form-row-item[data-v-1be0512c]{display:inline-block;width:25%}.modal-detail-form-center .form-delete-tips[data-v-1be0512c]{padding:0 0 0 100px;font-size:12px;color:#f20}", ""]);

// exports
